// extracted by mini-css-extract-plugin
module.exports = {"title":"ExtraLinks_title__6mjm_","inner":"ExtraLinks_inner__yZ4nm"};